import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import WebsiteAssistant from './WebsiteAssistant';
import { blogPosts, getBlogPostBySlug } from '../data/blogPosts';
import { Button } from './ui/button';

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = getBlogPostBySlug(slug);

  if (!post) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar onBookNow={() => {}} />
        <main className="mx-auto flex min-h-screen max-w-4xl items-center justify-center px-4 pt-32 text-center">
          <div className="space-y-6">
            <p className="text-sm font-medium uppercase tracking-widest text-stone-500">Blog</p>
            <h1 className="text-4xl font-bold text-stone-900">Article Not Found</h1>
            <Link to="/" className="inline-flex rounded-full bg-stone-900 px-5 py-3 text-sm font-semibold text-white">
              Back To Homepage
            </Link>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar onBookNow={() => {}} />

      <main className="mx-auto max-w-5xl px-4 pb-20 pt-32 sm:px-6 lg:px-8">
        <div className="mb-10 max-w-3xl space-y-5">
          <Link to="/" className="text-sm font-medium uppercase tracking-widest text-stone-500">
            Back To Homepage
          </Link>
          <div className="flex flex-wrap items-center gap-3 text-sm text-stone-500">
            <span className="rounded-full bg-stone-100 px-3 py-1 font-medium text-stone-700">{post.category}</span>
            <span>{post.readTime}</span>
            <span>{post.publishedAt}</span>
          </div>
          <h1 className="text-4xl font-bold leading-tight text-stone-900 md:text-6xl">{post.title}</h1>
          <p className="text-lg leading-8 text-stone-600">{post.description}</p>
        </div>

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_18rem]">
          <article className="space-y-6 rounded-3xl border border-stone-200 bg-white p-8 shadow-sm">
            {post.content.map((paragraph) => (
              <p key={paragraph} className="text-lg leading-8 text-stone-700">
                {paragraph}
              </p>
            ))}
          </article>

          <aside className="space-y-6">
            <div className="rounded-3xl border border-stone-200 bg-stone-50 p-6">
              <h2 className="mb-4 text-lg font-bold text-stone-900">Target Keywords</h2>
              <div className="flex flex-wrap gap-2">
                {post.keywords.map((keyword) => (
                  <span
                    key={keyword}
                    className="rounded-full border border-stone-200 bg-white px-3 py-1 text-xs text-stone-700"
                  >
                    {keyword}
                  </span>
                ))}
              </div>
            </div>

            <div className="rounded-3xl border border-stone-200 bg-stone-50 p-6">
              <h2 className="mb-4 text-lg font-bold text-stone-900">More Articles</h2>
              <div className="space-y-3">
                {blogPosts
                  .filter((item) => item.slug !== post.slug)
                  .map((item) => (
                    <Link
                      key={item.slug}
                      to={`/blog/${item.slug}`}
                      className="block rounded-2xl border border-stone-200 bg-white p-4 text-sm font-medium text-stone-800 transition-colors hover:bg-stone-100"
                    >
                      {item.title}
                    </Link>
                  ))}
              </div>
            </div>

            <div className="rounded-3xl border border-stone-200 bg-stone-900 p-6 text-white">
              <h2 className="mb-3 text-lg font-bold">Book Your Wedding Coverage</h2>
              <p className="mb-4 text-sm leading-6 text-white/80">
                If you are planning a wedding in Kolkata or anywhere in India, discuss your event coverage,
                pre-wedding shoot, reels, album design, and timeline.
              </p>
              <Link to="/">
                <Button className="w-full bg-white text-stone-900 hover:bg-white/90">Go To Contact Section</Button>
              </Link>
            </div>
          </aside>
        </div>
      </main>

      <Footer />
      <WebsiteAssistant albums={[]} videos={[]} />
    </div>
  );
};

export default BlogPostPage;
